import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconAppearanceLightMode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAppearanceLightMode"><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16V21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3V8ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAppearanceLightMode;
